import React, { useEffect } from 'react';
import {
    TextField,
    InputAdornment,
    IconButton,
    makeStyles,
} from '@material-ui/core';
import { Add, Remove } from '@material-ui/icons';

const useStyles = makeStyles({
    button: {
        padding: 0,
    },
    input: {
        width: '7rem',
        '& div': {
            '& input': {
                paddingTop: '.8rem',
                paddingBottom: '.8rem',
                textAlign: 'center',
            },
        },
    },
});

const NumberSelector = ({ number, setNumber, disabled }) => {
    const classes = useStyles();
    const handleDecrement = () => {
        if (number > 1) {
            setNumber(number - 1);
        }
    };
    useEffect(() => {
        if (number && number < 1) {
            setNumber(1);
        }
    }, [number]);
    return (
        <TextField
            type="number"
            value={number}
            onChange={(event) => setNumber(+event.target.value)}
            variant="outlined"
            label="Amount"
            className={classes.input}
            disabled={disabled}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <IconButton
                            className={classes.button}
                            onClick={() => {
                                setNumber(number + 1);
                            }}
                            disabled={disabled}
                        >
                            <Add />
                        </IconButton>
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            className={classes.button}
                            onClick={handleDecrement}
                            disabled={disabled}
                        >
                            <Remove />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    );
};

export default NumberSelector;
